import { useState } from 'react';

const faqList = [
  {
    q: 'Что включает обучение менеджменту и лидерству?',
    a: 'Обучение включает развитие ключевых управленческих компетенций: лидерство и влияние, постановку задач, делегирование, контроль, обратную связь, мотивацию команды, управление конфликтами, принятие решений, управленческие коммуникации, управление изменениями и развитие сотрудников. Программа адаптируется под конкретные задачи и уровень руководителей компании.',
  },
  {
    q: 'Для каких руководителей подходит обучение?',
    a: 'Обучение подходит для всех уровней: новых руководителей, недавно назначенных на должность; руководителей среднего звена; РОПов и коммерческих руководителей; топ-менеджеров; управленческих команд целиком; кадрового резерва, готовящегося к руководящим позициям. Для каждой аудитории программа адаптируется по содержанию и формату.',
  },
  {
    q: 'Чем обучение руководителей отличается от обычного тренинга?',
    a: 'Это системный процесс, а не разовое мероприятие: диагностика реальных управленческих задач, адаптация программы под отрасль и уровень руководителей, практическая отработка на реальных кейсах, внедрение инструментов в ежедневную управленческую практику и сопровождение после обучения. Мы не читаем лекции — мы меняем управленческое поведение.',
  },
  {
    q: 'Какие управленческие навыки развиваются на тренинге?',
    a: 'На тренинге развиваются: лидерство и влияние на команду, постановка задач с измеримым результатом, делегирование без микроменеджмента, контроль через систему контрольных точек, обратная связь, меняющая поведение, мотивация сотрудников, управление конфликтами, принятие решений в условиях неопределённости, эффективные коммуникации и управление изменениями.',
  },
  {
    q: 'Сколько длится обучение руководителей?',
    a: 'Формат и продолжительность зависят от задач компании. Корпоративный тренинг — 1-3 дня интенсивной практики. Модульная программа — несколько модулей с практикой между встречами. Управленческая программа — комплексное развитие на протяжении нескольких месяцев. Точная продолжительность и формат определяются после диагностики.',
  },
  {
    q: 'Можно ли адаптировать программу под нашу компанию?',
    a: 'Да, адаптация — обязательный этап подготовки. Мы не начинаем с готовой презентации. Сначала разбираемся, какие управленческие задачи действительно существуют в компании, изучаем отраслевую специфику, уровень руководителей и ожидания бизнеса. После этого программа настраивается под реальные потребности.',
  },
  {
    q: 'Можно ли обучать руководителей онлайн?',
    a: 'Да, онлайн-формат доступен и эффективен для распределённых команд. Он удобен для модульных программ с практикой между встречами. Однако для командообразующих элементов и интенсивной отработки навыков офлайн-формат даёт более высокую вовлечённость. Оптимальный вариант — blended: сочетание очных интенсивов с онлайн-сопровождением.',
  },
  {
    q: 'Подходит ли программа для новых руководителей?',
    a: 'Да, для новых руководителей это особенно важно. Когда лучшего специалиста повышают до руководителя, он сталкивается с принципиально новой ролью: теперь он отвечает не за свой результат, а за результат команды. Программа помогает освоить постановку задач, делегирование, контроль, обратную связь и другие управленческие инструменты с первых дней в новой роли.',
  },
  {
    q: 'Можно ли проводить обучение для всей управленческой команды?',
    a: 'Да, обучение всей управленческой команды — один из самых эффективных форматов. Когда все руководители компании проходят программу вместе, формируется единый управленческий язык, общие подходы к постановке задач, контролю и обратной связи. Это особенно важно для компаний, которые масштабируются или внедряют изменения.',
  },
  {
    q: 'Что происходит после тренинга?',
    a: 'После тренинга при необходимости продолжается работа с командой: разбор реальных управленческих ситуаций, поддержка внедрения инструментов, ответы на вопросы участников. Компания также может получить алгоритмы, чек-листы и шаблоны для дальнейшего использования. Сопровождение повышает вероятность закрепления навыков в практике.',
  },
  {
    q: 'Можно ли добавить сопровождение?',
    a: 'Да, сопровождение — это отдельный элемент программы, который повышает вероятность того, что новые навыки закрепятся в практике, а не забудутся через несколько недель. Формат сопровождения подбирается под задачу: это могут быть регулярные онлайн-встречи, разбор кейсов участников, ответы на вопросы в чате или индивидуальные коуч-сессии.',
  },
  {
    q: 'Как оценить эффективность обучения руководителей?',
    a: 'Эффективность оценивается на нескольких уровнях: реакция участников (удовлетворённость программой), усвоение знаний и навыков, применение инструментов в работе (изменение управленческого поведения) и влияние на бизнес-показатели. Через 1-3 месяца после обучения мы определяем, какие изменения произошли в управленческой практике.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об обучении менеджменту и лидерству
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}